<template>
  <div class="basicBreadCrumb">
    <el-breadcrumb-item>基础设置</el-breadcrumb-item>
    <el-breadcrumb-item :class="{ active: item.url===$route.path }" :to="item.url" v-for="item in breadcrumbList" :key="item.id">{{item.name}}</el-breadcrumb-item>
  </div>
</template>
<script>
export default {
  data () {
    return {
      breadcrumbList: [],
      basicList: [
        { url: '/', name: '店铺设置', index: '3-1' },
        { url: '/basic/classify', name: '分类设置', index: '3-2' },
        { url: '/basic/brand', name: '品牌管理', index: '3-3' },
        { url: '/basic/selection', name: '商品选品', index: '3-4' },
        { url: '/basic/goodsManage', name: '商品管理', index: '3-5' },
        { url: '/basic/storeSetup', name: '店铺设置', index: '3-6' }
      ]
    }
  },
  mounted () {
    this.setBreadCrumb(this.$route)
  },
  watch: {
    $route (to, from) {
      this.setBreadCrumb(to)
    }
  },
  methods: {
    setBreadCrumb (to) {
      let currentUrl = this.basicList.filter(item => item.url === to.path)
      if (!this.breadcrumbList.some(item => item.url === to.path)) {
        this.breadcrumbList = this.breadcrumbList.concat(currentUrl)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/breadcrumb/basicBreadCrumb.vue